/*global $*/
"use strict";

var _ = require('underscore');
var HumanView = require('human-view');
var templates = require('../templates');

module.exports = HumanView.extend({
    template: templates.includes.mucMessage,
    initialize: function initialize(opts) {
        this.render();
    },
    classBindings: {
        mine: '.message',
        pending: '.message',
        delayed: '.message',
        edited: '.message',
        meAction: '.message'
    },
    textBindings: {
        body: '.body',
        nick: '.nick',
        formattedTime: '.timestamp'
    },
    render: function render() {
        this.renderAndBind({ message: this.model });
        return this;
    }
});


//////////////////
// WEBPACK FOOTER
// ./views/mucMessage.js
// module id = 814
// module chunks = 2